import { request } from 'utils/request';
import { header } from 'utils/auth';

const SETTINGS_TYPE = 'DAILY_CDP_SYNC_CONFIGURATION';

const fetchDealerDailyCdpSyncSettingsFromAPI = async ({
  dealershipId,
}: {
  dealershipId: string;
}): Promise<any> => {
  const requestURL = `/api/v2/dealer-settings?dealer=${dealershipId}&type=${SETTINGS_TYPE}`;
  const response: any = await request(requestURL, {
    method: 'GET',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: header(),
    }),
  });

  if (!response) {
    throw new Error('Failed to fetch dealer daily CDP sync settings from API');
  }
  return response;
};

const updateDealerDailyCdpSyncSettingsFromAPI = async ({
  dealershipId,
  data,
  settingsId,
}: {
  dealershipId: string;
  data: any;
  settingsId: string;
}): Promise<any> => {
  const requestURL = `/api/v2/dealer-settings/${settingsId}?dealer=${dealershipId}`;
  const response: any = await request(requestURL, {
    method: 'PUT',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: header(),
    }),
    body: JSON.stringify(data),
  });

  if (!response) {
    throw new Error('Failed to update dealer daily CDP sync settings from API');
  }
  return response;
};

const initializeDealerDailyCdpSyncSettingsFromAPI = async ({
  dealerId,
}: {
  dealerId: string;
}): Promise<any> => {
  const requestURL = `/api/v2/dealer-settings/initialize?dealer_id=${dealerId}&type=${SETTINGS_TYPE}`;
  const response: any = await request(requestURL, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Authorization: header(),
    }),
  });

  if (!response) {
    throw new Error(
      'Failed to initialize dealer daily CDP sync settings from API',
    );
  }

  const res = await response;
  const status = res?.statusCode ?? res?.myAutoIQ_status_code ?? res?.errorCode;
  const msg = res?.message ?? res?.myAutoIQ_error_message;
  if (typeof status === 'number' && status >= 400) {
    throw new Error(
      msg || 'Failed to initialize dealer daily CDP sync settings',
    );
  }
  return res;
};

export const fetchDealerDailyCdpSyncSettings = async ({
  dealershipId,
}: {
  dealershipId: string;
}): Promise<any> => {
  return fetchDealerDailyCdpSyncSettingsFromAPI({ dealershipId });
};

export const updateDealerDailyCdpSyncSettings = async ({
  dealershipId,
  data,
  settingsId,
}: {
  dealershipId: string;
  data: any;
  settingsId: string;
}): Promise<any> => {
  return updateDealerDailyCdpSyncSettingsFromAPI({
    dealershipId,
    data,
    settingsId,
  });
};

export const initializeDealerDailyCdpSyncSettings = async ({
  dealerId,
}: {
  dealerId: string;
}): Promise<any> => {
  return initializeDealerDailyCdpSyncSettingsFromAPI({ dealerId });
};
